import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin, ShoppingBag, Building2, HeadphonesIcon, Cookie } from "lucide-react";
import { openCookieSettings } from "@/components/CookieConsentBanner";
const Footer = () => {
  const shopLinks = [{
    name: "All Products",
    href: "/shop"
  }, {
    name: "Artisan Gifts",
    href: "/gifts"
  }, {
    name: "Terracotta",
    href: "/category/terracotta"
  }, {
    name: "Madhubani Art",
    href: "/category/madhubani"
  }, {
    name: "Wooden Crafts",
    href: "/category/wooden"
  }, {
    name: "Jewelry",
    href: "/category/jewelry"
  }, {
    name: "Compare",
    href: "/compare"
  }];
  const companyLinks = [{
    name: "Our Story",
    href: "/story"
  }, {
    name: "Craft Traditions",
    href: "/crafts"
  }, {
    name: "Heritage Map",
    href: "/regions"
  }, {
    name: "Meet Artisans",
    href: "/artisans"
  }, {
    name: "Wholesale",
    href: "/wholesale"
  }, {
    name: "Rewards",
    href: "/loyalty"
  }, {
    name: "Gift Cards",
    href: "/gift-cards"
  }, {
    name: "Donate",
    href: "/donate"
  }];
  const supportLinks = [{
    name: "Contact Us",
    href: "/contact"
  }, {
    name: "Support Tickets",
    href: "/support"
  }, {
    name: "FAQs",
    href: "/faq"
  }, {
    name: "Shipping Info",
    href: "/shipping"
  }, {
    name: "Returns & Refunds",
    href: "/returns"
  }, {
    name: "Track Order",
    href: "/track"
  }, {
    name: "Bug Bounty",
    href: "/bug-bounty"
  }];
  return <footer className="bg-earth text-cream relative overflow-hidden">
      {/* Decorative SVG Patterns - Warli & Traditional Motifs */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        {/* Warli-style dancing figures */}
        <svg className="absolute top-8 left-8 w-32 h-32 text-cream" viewBox="0 0 100 100" fill="none">
          {/* Dancing figure 1 */}
          <circle cx="25" cy="15" r="5" fill="currentColor" />
          <line x1="25" y1="20" x2="25" y2="40" stroke="currentColor" strokeWidth="1.5" />
          <line x1="25" y1="25" x2="15" y2="35" stroke="currentColor" strokeWidth="1.5" />
          <line x1="25" y1="25" x2="35" y2="30" stroke="currentColor" strokeWidth="1.5" />
          <line x1="25" y1="40" x2="18" y2="55" stroke="currentColor" strokeWidth="1.5" />
          <line x1="25" y1="40" x2="32" y2="55" stroke="currentColor" strokeWidth="1.5" />
          {/* Dancing figure 2 */}
          <circle cx="55" cy="18" r="5" fill="currentColor" />
          <line x1="55" y1="23" x2="55" y2="43" stroke="currentColor" strokeWidth="1.5" />
          <line x1="55" y1="28" x2="45" y2="33" stroke="currentColor" strokeWidth="1.5" />
          <line x1="55" y1="28" x2="65" y2="38" stroke="currentColor" strokeWidth="1.5" />
          <line x1="55" y1="43" x2="48" y2="58" stroke="currentColor" strokeWidth="1.5" />
          <line x1="55" y1="43" x2="62" y2="58" stroke="currentColor" strokeWidth="1.5" />
          {/* Dancing figure 3 */}
          <circle cx="85" cy="12" r="5" fill="currentColor" />
          <line x1="85" y1="17" x2="85" y2="37" stroke="currentColor" strokeWidth="1.5" />
          <line x1="85" y1="22" x2="75" y2="32" stroke="currentColor" strokeWidth="1.5" />
          <line x1="85" y1="22" x2="95" y2="27" stroke="currentColor" strokeWidth="1.5" />
          <line x1="85" y1="37" x2="78" y2="52" stroke="currentColor" strokeWidth="1.5" />
          <line x1="85" y1="37" x2="92" y2="52" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        
        {/* Pottery/Terracotta pot shape */}
        <svg className="absolute top-6 right-12 w-24 h-28 text-golden" viewBox="0 0 80 100" fill="none">
          <path d="M30 15 Q25 15 25 20 L25 25 Q25 28 30 28 L50 28 Q55 28 55 25 L55 20 Q55 15 50 15 Z" stroke="currentColor" strokeWidth="1" />
          <path d="M28 28 Q20 40 18 60 Q16 80 25 90 L55 90 Q64 80 62 60 Q60 40 52 28" stroke="currentColor" strokeWidth="1" />
          <path d="M22 50 Q40 45 58 50" stroke="currentColor" strokeWidth="0.5" />
          <path d="M20 65 Q40 60 60 65" stroke="currentColor" strokeWidth="0.5" />
          <path d="M23 78 Q40 73 57 78" stroke="currentColor" strokeWidth="0.5" />
        </svg>
        
        {/* Traditional ox cart wheel */}
        <svg className="absolute bottom-24 left-16 w-28 h-28 text-cream" viewBox="0 0 100 100" fill="none">
          <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="50" cy="50" r="8" fill="currentColor" />
          {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle) => (
            <line key={angle} x1="50" y1="50" x2="50" y2="12" stroke="currentColor" strokeWidth="1" transform={`rotate(${angle} 50 50)`} />
          ))}
        </svg>
        
        {/* Block print sun motif */}
        <svg className="absolute top-1/3 right-1/3 w-20 h-20 text-cream" viewBox="0 0 100 100" fill="none">
          <circle cx="50" cy="50" r="15" fill="currentColor" />
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
            <g key={angle} transform={`rotate(${angle} 50 50)`}>
              <path d="M50 30 L45 10 L50 5 L55 10 Z" fill="currentColor" />
            </g>
          ))}
        </svg>
        
        {/* Warli-style hut */}
        <svg className="absolute bottom-16 right-24 w-24 h-24 text-cream" viewBox="0 0 100 100" fill="none">
          <path d="M20 60 L50 25 L80 60 Z" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <rect x="25" y="60" width="50" height="30" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <rect x="42" y="70" width="16" height="20" stroke="currentColor" strokeWidth="1" fill="none" />
        </svg>
        
        {/* Traditional rangoli corner pattern */}
        <svg className="absolute bottom-4 left-4 w-24 h-24 text-golden" viewBox="0 0 100 100" fill="none">
          <path d="M10 90 Q10 50 50 50 Q90 50 90 10" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M20 90 Q20 60 50 60 Q80 60 80 20" stroke="currentColor" strokeWidth="0.5" fill="none" />
          <circle cx="50" cy="50" r="3" fill="currentColor" />
          <circle cx="30" cy="70" r="2" fill="currentColor" />
          <circle cx="70" cy="30" r="2" fill="currentColor" />
        </svg>
        
        {/* Tribal tree pattern */}
        <svg className="absolute top-1/2 left-1/4 w-16 h-24 text-cream" viewBox="0 0 60 100" fill="none">
          <line x1="30" y1="95" x2="30" y2="40" stroke="currentColor" strokeWidth="2" />
          <circle cx="30" cy="30" r="20" stroke="currentColor" strokeWidth="1" fill="none" />
          <circle cx="30" cy="30" r="12" stroke="currentColor" strokeWidth="0.5" fill="none" />
          <circle cx="30" cy="30" r="5" fill="currentColor" />
        </svg>
        
        {/* Geometric border pattern top */}
        <svg className="absolute top-0 left-1/4 w-1/2 h-8 text-cream" viewBox="0 0 200 30" preserveAspectRatio="none" fill="none">
          {[0, 20, 40, 60, 80, 100, 120, 140, 160, 180].map((x) => (
            <path key={x} d={`M${x} 0 L${x + 10} 15 L${x} 30 L${x + 10} 15 Z`} stroke="currentColor" strokeWidth="0.5" fill="none" />
          ))}
        </svg>
        
        {/* Birds in flight - Warli style */}
        <svg className="absolute top-12 left-1/2 w-32 h-16 text-cream" viewBox="0 0 120 50" fill="none">
          <path d="M10 25 Q20 15 30 25 Q20 20 10 25" stroke="currentColor" strokeWidth="1" />
          <path d="M40 20 Q50 10 60 20 Q50 15 40 20" stroke="currentColor" strokeWidth="1" />
          <path d="M70 28 Q80 18 90 28 Q80 23 70 28" stroke="currentColor" strokeWidth="1" />
          <path d="M95 22 Q105 12 115 22 Q105 17 95 22" stroke="currentColor" strokeWidth="1" />
        </svg>
      </div>

      {/* Main Footer */}
      <div className="container py-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center">
                <span className="text-earth font-display text-xl font-bold">G</span>
              </div>
              <span className="font-display text-xl font-semibold text-cream">
                Gaon<span className="text-golden">ova</span>
              </span>
            </Link>
            <p className="text-cream/70 mb-4 max-w-sm text-sm leading-relaxed">
              Bringing authentic village craftsmanship to modern homes. Every purchase supports rural artisan communities.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-colors" aria-label="Follow us on Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-cream/10 rounded-full flex items-center justify-center hover:bg-cream/20 transition-colors" aria-label="Subscribe to our YouTube channel">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div>
            <h3 className="font-display text-base font-semibold mb-4 text-golden flex items-center gap-2">
              <ShoppingBag className="h-4 w-4" />
              Shop
            </h3>
            <ul className="space-y-2 text-sm">
              {shopLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-display text-base font-semibold mb-4 text-golden flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              Company
            </h3>
            <ul className="space-y-2 text-sm">
              {companyLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Support & Contact */}
          <div>
            <h3 className="font-display text-base font-semibold mb-4 text-golden flex items-center gap-2">
              <HeadphonesIcon className="h-4 w-4" />
              Support
            </h3>
            <ul className="space-y-2 text-sm mb-4">
              {supportLinks.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-cream/70 hover:text-cream transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
            
            <div className="space-y-2 text-xs">
              <a href="mailto:hello@gaonova.com" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors">
                <Mail className="h-4 w-4" />
                hello@gaonova.com
              </a>
              <a href="tel:+911234567890" className="flex items-center gap-2 text-cream/70 hover:text-cream transition-colors">
                <Phone className="h-4 w-4" />
                +91 12345 67890
              </a>
              <p className="flex items-start gap-2 text-cream/70">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                Rural Artisan Hub, Kolkata, India
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/10">
        <div className="container py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-cream/60">
          <p>© 2026 Gaonova. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-cream transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-cream transition-colors">Terms of Service</Link>
            <Link to="/sitemap" className="hover:text-cream transition-colors">Sitemap</Link>
            <button
              onClick={openCookieSettings}
              className="inline-flex items-center gap-1.5 hover:text-cream transition-colors"
            >
              <Cookie className="h-3.5 w-3.5" />
              Cookie preferences
            </button>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
